<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppTextarea } from '@shared/ui/fields'

import { useKidFields } from '../model/kid-fields.hook'

defineOptions({
  name: 'KidNotesInfo',
})

const {
  refNotes,
  setNotes,
} = useKidFields()
</script>

<template>
  <div class="kid-notes-info">
    <AppText name="body1-medium">
      Note
    </AppText>
    <AppTextarea
      name="notes"
      placeholder="Type here..."
      :value="refNotes"
      @input="setNotes"
    />
  </div>
</template>

<style scoped lang="scss" src="./KidNotesInfo.scss" />
